import { useEffect, useRef, useState, useCallback } from "react";
import SupportLoader from "../common/SupportLoader";
import { Toast } from "primereact/toast";
import moment from "moment";

export default function ExistingPolicyListStep(props: any) {
  const toast: any = useRef("");

  return (
    <div className="card border-0">
      <Toast ref={toast} />
      <div className=" border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Policies</h6>
        <p className="text-muted mb-0 text-12">Select an existing policy for comparison(Optional)</p>
      </div>

      {props.nowcertsPolicyLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "30vh" }}>
          <SupportLoader />
        </div>
      ) : (
        <>
          {props.clientName.length > 0 ? (
            props.nowCertPolicyData.length == 0 ? (
              <p className="mt-5" style={{ color: "black", textAlign: "center", background: "#fff", padding: "5px 10px", borderRadius: "4px" }}>
                Oops ! No policy found
              </p>
            ) : (
              <>
               <div style={{ height: "50vh", overflowY: "auto" }}>
                <div className="row mt-2 px-4 mx-auto" >
                  {props.nowCertPolicyData.map((policy: any) => (
                    <div className="col-md-6 col-lg-4 mb-3 show-cursor  " onClick={() => props.onPolicySelected(policy)}>
                      <div
                        className={
                          props.selectedPolicyId == policy.databaseId ? "card  shadow-sm transition bg-light border-purple" : "card border transition"
                        }
                      >
                        <div className="card-body text-12">
                          <h6 className="card-title mb-1 ">
                            {policy.linesOfBusiness[0]} - {policy.policyNumber}
                          </h6>
                          <p className="mb-1 text-muted">Premium: ${policy.totalPremium}</p>
                          <p className="mb-0 text-muted">
                            Date:{" "}
                            {policy.effectiveDate != null || policy.effectiveDate !== ""
                              ? moment.utc(policy.effectiveDate, "YYYY-MM-DD").format("MM/DD/YYYY")
                              : ""}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                </div>
              </>
            )
          ) : null}
        </>
      )}
    </div>
  );
}
